import Vue from 'vue'
import initTableFields from './tableFields';
// import md5 from './getMd5';

const _ = require('underscore');

const initPipelineEvents = () => ({
  disableReversePipelineMove: false,
  enableMoveFromClosedStatus: false,
  orderAttachment1cToAmo: {
    type: 1, //  0 - всегда создавать новую сделку; 1 - прикреплять к любой открыткой сделке контрагента; 2 - прикреплять к сделке в определенных этапах
    searchStatuses: [], // [1, 2, 3, ...] (142, 142 - игнорируем)
    tags: '', // tag1, tag2
  },
  
  events1cToAmo: [
    // пример структуры
    // {
    //     type: '', //  lead_attached, realization_created
    //     statusesFrom: [324, 324, 234],
    //     statusTo: 1,
    // },
  ],
  eventsAmoTo1c: [
    // пример структуры
    // {
    //     type: '', // oder_1c, printed_forms
    //     action: '', // create, delete, ...
    //     content: '', // {название печ. формы}, ...
    //     statusesFrom: [324, 324, 234],
    //     statusTo: 1,
    // },
  ]
})

const initExportProductsText = () => ({
  type: 0, // 0 - не выгружать, 1 - выгружать в примечание, 2 - выгружать в поле сделки, 3 - выгрузать в примечание и в поле
  cfId: 0, // id кастомного поля сделки/покупателя
})

export default function (data) {

  if (!data?.source) {
    Vue.set(data, 'source', [])
  }

  if (!data.defaults.hasOwnProperty('discountViewType')){ // eslint-disable-line no-prototype-builtins
    Vue.set(data.defaults, 'discountViewType', 0)
  }

  if (!data.defaults?.managerId) {
    Vue.set(data.defaults, 'managerId', '')
  }

  if (!data.defaults?.showEmptyRemains) {
    Vue.set(data.defaults, 'showEmptyRemains', false)
  }

  if (!data.defaults?.isDescriptionEnabled) {
    Vue.set(data.defaults, 'isDescriptionEnabled', false)
  }

  if (!data.defaults?.isContractRequired) {
    Vue.set(data.defaults, 'isContractRequired', false)
  }

  if (!data.defaults?.disableOrganizationChange) {
    Vue.set(data.defaults, 'disableOrganizationChange', false)
  }

  if (!data.defaults?.ownerAgreementFirst) {
    Vue.set(data.defaults, 'ownerAgreementFirst', false)
  }

  if (!data?.extraCfs) {
    Vue.set(data, 'extraCfs', {})
  }

  if (!data?.extraCfs?.descriptionCfId) {
    Vue.set(data.extraCfs, 'descriptionCfId', '')
  }

  if (!data?.extraCfs?.payCalendarCfId) {
    Vue.set(data.extraCfs, 'payCalendarCfId', '')
  }

  if (!data?.storage) {
    Vue.set(data, 'storage', {
      use: false,
      storageId: "",
      storageType: "",
      storageMail: "",
      storageAuthLink: ""
    })
  }

  if (!data.defaults.hasOwnProperty('showCodeColumn')){ // eslint-disable-line no-prototype-builtins
      Vue.set(data.defaults, 'showCodeColumn', false)
  }

  if (!data.defaults.hasOwnProperty('updateDataEnabled')){ // eslint-disable-line no-prototype-builtins
    Vue.set(data.defaults, 'updateDataEnabled', false)
  }

  if (!data.defaults.hasOwnProperty('disablePriceChangeOnAdd')){ // eslint-disable-line no-prototype-builtins
    Vue.set(data.defaults, 'disablePriceChangeOnAdd', false)
  }

  if (!data.defaults.hasOwnProperty('linkedContactsType')){ // eslint-disable-line no-prototype-builtins
    Vue.set(data.defaults, 'linkedContactsType', [0])
  }

  if(!data.defaults.hasOwnProperty('isSignatoriesEnabled')){ // eslint-disable-line no-prototype-builtins
      data.defaults.isSignatoriesEnabled = false;
  }

  if (!data.defaults.hasOwnProperty('checkEmptyContactsData')){ // eslint-disable-line no-prototype-builtins
      data.defaults.checkEmptyContactsData = true;
  }

  if(!data.defaults.hasOwnProperty('isContractCreationEnabled')){ // eslint-disable-line no-prototype-builtins
      data.defaults.isContractCreationEnabled = true;
  }

  if(!data.defaults.hasOwnProperty('disableCommonAgreements')){ // eslint-disable-line no-prototype-builtins
    data.defaults.disableCommonAgreements = false;
  }

  if(!data.defaults.hasOwnProperty('disableCommonContracts')){ // eslint-disable-line no-prototype-builtins
    data.defaults.disableCommonContracts = false;
  }

  if(typeof data.defaults.stockCountBySearch=='undefined'){ // если не было настройки Остатки при подборе
      data.defaults.stockCountBySearch = 0;
  }

  const entities = ['company', 'contact', 'lead']
  const exceptFields = ['payment_detail', 'payment_flag', 'partial_payment_flag', 'payment_sum', 'payment_full_date']

  entities.forEach(entity => {
    for (let key in data.orderFields[entity]) {
      let fSet = data.orderFields[entity][key]
      if (!(fSet.hasOwnProperty('sync') || exceptFields.includes(key))) { /* eslint-disable-line no-prototype-builtins */
        Vue.set(fSet, 'sync', 0)
      }
    }
  })

  if (!data.defaults?.showStockColumn) { // если нет настройки показывать столбец "остаток"
    data.defaults.showStockColumn = 0
  }

  if (data.defaults.hasOwnProperty('stockWorktype') && data.defaults.stockWorktype == 3) { /* eslint-disable-line no-prototype-builtins */
    data.defaults.stockWorktype = 1
    data.defaults.showStockColumn = 1
  }

  //прикручиваем поля секции iframe если еще не были добавлены в объект настроек
  if (!data?.iframe) {
    Vue.set(data, 'iframe', {
      use: false,
      login: '',
      password: ''
    })
  }

  //прикручиваем поля оплат, если еще не были добавлены в объект настроек
  if (!data?.paysInfo) {
    Vue.set(data, 'paysInfo', [
      {dateCf: '', sumCf: ''},
      {dateCf: '', sumCf: ''},
      {dateCf: '', sumCf: ''},
      {dateCf: '', sumCf: ''},
    ])
  }

  //прикручиваем pipelineEvents, если еще не были добавлены в объект настроек
  if (_.isEmpty(data.pipelineEvents)) {
    data.pipelineEvents = initPipelineEvents();
  }

  if (!data.pipelineEvents.hasOwnProperty('disableReversePipelineMove')){ // eslint-disable-line no-prototype-builtins
    Vue.set(data.pipelineEvents, 'disableReversePipelineMove', false)
  }

  if (!data.pipelineEvents.hasOwnProperty('enableMoveFromClosedStatus')){ // eslint-disable-line no-prototype-builtins
    Vue.set(data.pipelineEvents, 'enableMoveFromClosedStatus', false)
  }

  if (!data.defaults.hasOwnProperty('isStockRequired')) { // eslint-disable-line no-prototype-builtins
    Vue.set(data.defaults, 'isStockRequired', true)
  }

  if (!data.defaults.hasOwnProperty('isOrganizationRequired')) { // eslint-disable-line no-prototype-builtins
    Vue.set(data.defaults, 'isOrganizationRequired', true)
  }

  if (!data.defaults.hasOwnProperty('isProductsEnabled')) { // eslint-disable-line no-prototype-builtins
    Vue.set(data.defaults, 'isProductsEnabled', false)
  }

  if (!data?.partners) { // если нет настройки партнеры
    Vue.set(data, 'partners', {
      cf_company_partner: '',
      cf_contact_partner: '',
      directory_code: '',
      directory_type: ''
    })
  }

  if (!data?.organizationsDefaults) { // если нет настроек по умолчанию для организаций
    Vue.set(data, 'organizationsDefaults', [])
  }

  if (!data.defaults?.stockFormat) { // если нет настройки формата остатков
    data.defaults.stockFormat = 0
  }

  if (!data?.cardsFields) { // если нет настройки справочников внутри сущностей
    Vue.set(data, 'cardsFields', [])
  }

  if (!data.defaults?.showAgreementsPrices) { // если нет настройки показывать цены в зависимости от соглашения
    data.defaults.showAgreementsPrices = false
  }

  if (!data.defaults.hasOwnProperty('isRealizationButtonEnabled')) { // eslint-disable-line no-prototype-builtins
    data.defaults.isRealizationButtonEnabled = false;
  }

  if (!Array.isArray(data.defaults?.disablePriceChange)) { // если нет настройки запрета редактирования цены
    Vue.set(data.defaults, 'disablePriceChange', [])
  }

  if (!data.defaults?.disableDiscountChange) { // если нет настройки запрета редактирования скидки
    data.defaults.disableDiscountChange = 0
  }

  if (!data.defaults?.isEvotorButtonEnabled) { // если нет настройки реализации
    data.defaults.isEvotorButtonEnabled = false;
  }

  if (!data.defaults?.isAutoDiscountEnabled) { // если нет настройки реализации
    data.defaults.isAutoDiscountEnabled = false;
  }

  if (!data.defaults?.isInvoicesEnabled) { // если нет настройки реализации
    data.defaults.isInvoicesEnabled = false;
  }

  if (!data.defaults?.isPartialRealizationEnabled) { // если нет настройки реализации
    data.defaults.isPartialRealizationEnabled = false;
  }

  if (!data.defaults?.isPaysCalendarEnabled) { // если нет настройки реализации
    data.defaults.isPaysCalendarEnabled = false;
  }

  if (!data.defaults?.partnerId) { // если нет партнера
    data.defaults.partnerId = ''
  }

  if (!data.defaults.currency) { // если не заполнена валюта
    data.defaults.currency = 'руб';
  }
  if (!data.defaults.exportProductsText) { // если не заполнена валюта
    data.defaults.exportProductsText = initExportProductsText();
  }
  if (!data.defaults.appendCfToLeadPrice) { // если не заполнена валюта
    data.defaults.appendCfToLeadPrice = [];
  }
  if (!data.defaults.showErrors) { // если нет настройки отображения ошибок интеграции
    data.defaults.showErrors = [];
  }
  if (!data.defaults.updateEntityNames) { // если нет настройки обновления имен сущностей
    data.defaults.updateEntityNames = false;
  }
  if (!data.defaults.hasOwnProperty('updateResponsibleUser')) { // eslint-disable-line no-prototype-builtins
    data.defaults.updateResponsibleUser = [];
  }
  if (!data.defaults.defaultAgreement) { // если нет соглашения по умолчанию
    data.defaults.defaultAgreement = "";
  }
  if (!data.defaults.actionCloseAferSaveOrder) { // если не было настройки закрытия модалки
    data.defaults.actionCloseAferSaveOrder = 0;
  }
  if (!data.defaults.hasOwnProperty('actionCloseAferSaveRealization')) { // eslint-disable-line no-prototype-builtins
    data.defaults.actionCloseAferSaveRealization = 0;
  }
  if (!data.defaults.productCount) { // если не было настройки закрытия модалки
    data.defaults.productCount = 1;
  }
  if (typeof data.defaults.stockCountBySearch == 'undefined') { // если не было настройки Остатки при подборе
    data.defaults.stockCountBySearch = 0;
  }
  if (!data.defaults.disableWorkOrderStatuses) { // если не было настройки
    data.defaults.disableWorkOrderStatuses = [];
  }
  if (!data.defaults.enableContragentCreating) {
    data.defaults.enableContragentCreating = [];
  }
  if (!data.defaults.stockFormatItems) {
    Vue.set(data.defaults, 'stockFormatItems', [0])
  }
  if (data.defaults.stockFormat == 1){
    Vue.set(data.defaults, 'stockFormatItems', [0,1])
    data.defaults.stockFormat = 0
  }
  if (!data.orderFields.lead.order_sum) { // если не было настройки
    Vue.set(data.orderFields.lead, 'order_sum', {id: '', required: false})
  }
  if (!data.orderFields.lead.payment_full_date) { // если не было настройки
    Vue.set(data.orderFields.lead, 'payment_full_date', {id: '', required: false})
  }
  if (!data.orderFields.lead.payment_detail) { // если не было настройки
    Vue.set(data.orderFields.lead, 'payment_detail', {id: '', required: false})
  }
  if (!data.orderFields.lead.realization_created) { // если не было настройки
    Vue.set(data.orderFields.lead, 'realization_created', {id: '', required: false})
  }
  if (!data.orderFields.lead.realization_number) { // если не было настройки
    Vue.set(data.orderFields.lead, 'realization_number', {id: '', required: false})
  }
  if (!data.orderFields.lead.realization_date) { // если не было настройки
    Vue.set(data.orderFields.lead, 'realization_date', {id: '', required: false})
  }
  if (!data.orderFields.lead.order_description) { // если не было настройки
    Vue.set(data.orderFields.lead, 'order_description', {id: '', sync: 0, required: false})
  }
  if (!data.orderFields.company.company_tax_number) { // если не было настройки
    Vue.set(data.orderFields.company, 'company_tax_number', {id: '', sync: 0, required: false})
  }
  if (!data?.contractFields) {
    Vue.set(data, 'contractFields', {})
  }
  if (!data?.contractFields?.date_required) {
    Vue.set(data.contractFields, 'date_required', false)
  }
  if (!data?.contractFields?.date_to_required) {
    Vue.set(data.contractFields, 'date_to_required', false)
  }
  if (!data?.contractFields?.contract_custom_fields) { // если не было настройки
    Vue.set(data.contractFields, 'contract_custom_fields', [])
  }
  if (!data.orderFields.order_custom_fields) { // если не было настройки
    Vue.set(data.orderFields, 'order_custom_fields', [])
  }


  data.orderFields.order_custom_fields.forEach(v => {
    if (!v.hasOwnProperty('default')){ // eslint-disable-line no-prototype-builtins
        v.default = null
    }
  })

  if (!data.orderFields.lead.templates) { // если не было настройки
    Vue.set(data.orderFields.lead, 'templates', {});
  }
  if (!data.orderFields.lead.partial_payment_flag) { // если не было настройки
    Vue.set(data.orderFields.lead, 'partial_payment_flag', {id: '', required: false})
  }

  if (!data.hasOwnProperty('tableFields')) { /* eslint-disable-line no-prototype-builtins */
    Vue.set(data, 'tableFields', initTableFields())
  }

  if (!data.defaults.isRequestContractInfo) { // если не было настройки
    Vue.set(data.defaults, 'isRequestContractInfo', false)
  }
}